$(document).ready(function(){

  var form = $('.ajaxForm');
  form.on('submit', function(e) {
    e.preventDefault();
    var data = $(this).serialize();

    // -- Remove any existing error messages from previous attempts --
    var headerH = $('.header__navbar').outerHeight() + 15;
    $('html, body').animate({scrollTop: $('main').offset().top - headerH}, 'slow');
    $('.form__notifications .success, .form__notifications .error, .field-error').fadeOut();
    $('.field-error').remove();

    $.ajax({
      type: 'post',
      url: '/',
      dataType: 'json',
      data: data,
      beforeSend: function(response) {
        form.find('.btn--submit').attr('disabled', true);
      },
      success: function(response) {
        console.log(response);
        if (response.success || response.message == 'successMsg') {
          console.log('success');
          // -- Display notifications --
          $('.ajaxForm').delay(400).fadeOut();
          $('.form__notifications .success').delay(800).fadeIn();

        } else {
          console.log('error');
          // -- Display notifications --
          $('.form__notifications .error').delay(400).fadeIn();
          // -- Display errors --
					$.each(response.errors, function(key,value){
					  $('label[for="'+key+'"]').append('<small class="field-error">'+ value +'</small>');
					  $('.field-error').delay(400).fadeIn();
					});
        }
      },
      complete: function(response) {
        setTimeout(function(){
          form.find('.btn--submit').attr('disabled', false);
        },1000);
      }
    });

  });

});
